import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Utilities } from "./utilities";
import { TrackingProvider, _TRACKING_ENTITIES } from "./tracking";

@Injectable()
export class GalleryService {

  public action = "edit";

  constructor(
    private afdb: AngularFireDatabase,
    private utilities: Utilities,
    private tracking: TrackingProvider
  ) { }

  public getList(clientId: string, eventId: string = null) {
    let ref = `Clients/${clientId}/Interactivity/Gallery`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Gallery`;
    }
    return this.afdb.list<any>(ref).valueChanges();
  }

  public getItem(clientId: string, galleryId: string, eventId: string = null) {
    let ref = `Clients/${clientId}/Interactivity/Gallery/${galleryId}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Gallery/${galleryId}`;
    }
    return this.afdb.object<any>(ref).valueChanges();
  }

  public createOrEdit(clientId: string, info: any) {
    if (!info.id) {
      info.id = this.utilities.generateRamdomKey();
      this.action = "create";
    }

    let ref = `Clients/${clientId}/Interactivity/Gallery/${info.id}`;
    if (this.utilities.validateEventIdParam(info.eventId)) {
      ref = `Clients/${clientId}/Event/${info.eventId}/Gallery/${info.id}`;
    }

    return new Promise((res, rej) => {
      this.afdb.database
        .ref(ref)
        .set(info)
        .then(() => {
          this.tracking.trackEntityPromise(_TRACKING_ENTITIES.gallery, info.id, clientId, info.eventId, info, "Creacion/actualizacion galeria");
          return res(info.id);
        })
        .catch((e) => {
          return rej(e);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/gallery.service.ts